import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';
import { WrittenSignatureDTO } from '../model/written-signature-dto.model';

@Injectable()
export class SignatureApi extends BaseApi {

    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    saveSignature(userSignature: WrittenSignatureDTO) {
        let a = this.http.post<boolean>(this.baseUri + '/signature', userSignature);
        return a;
    }

    getSignature() {
        let a = this.http.get<WrittenSignatureDTO>(this.baseUri + '/signature');
        return a;
    }

    getSignatureForUserId(userId: string) {
        let a = this.http.get<WrittenSignatureDTO>(this.baseUri + '/signature/' + userId);
        return a;
    }
}
